/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_Title_TailInputs */

const en_platform_hero_title_tail = /** @type {(inputs: Platform_Hero_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not your inbox.`)
};

const pl_platform_hero_title_tail = /** @type {(inputs: Platform_Hero_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nie recepcję.`)
};

/**
* | output |
* | --- |
* | "not your inbox." |
*
* @param {Platform_Hero_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_title_tail = /** @type {((inputs?: Platform_Hero_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_title_tail(inputs)
	return en_platform_hero_title_tail(inputs)
});